import React from 'react'
import { inject, observer } from 'mobx-react'

import Modal from '../../../../../generic/Modal'
import EditReinfForm from './EditReinfForm'

const EditReinfModal = inject('companyProductStore', 'editReinfStore')(observer(props => {
  const { companyProductStore, editReinfStore } = props
  const { modalIsActive, isUpdating } = editReinfStore.state
  const modalOptions = [{
    text: 'Salvar',
    type: 'button',
    isLoading: isUpdating,
    onClick: () => editReinfStore.updateReinfInformation()
  }]
  return (
    <Modal
      isActive={modalIsActive}
      onClose={() => companyProductStore.closeProductModal('4REINF')}
      title='Editar empresa - 4REINF'
      options={modalOptions}
    >
      <EditReinfForm />
    </Modal>
  )
}))

export default EditReinfModal



// WEBPACK FOOTER //
// ./src/components/dashboard/config/companies/products/reinf/EditReinfModal.js